import { render, staticRenderFns } from "./DocumentsIterProcesal.vue?vue&type=template&id=6a0d90d4&lang=pug&"
import script from "./DocumentsIterProcesal.vue?vue&type=script&lang=js&"
export * from "./DocumentsIterProcesal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports